let React = require("react");

let DataActionUtil = require("../../util/DataActionUtil.js");

class InvitePeopleHub extends React.Component {
    constructor(){
        super();

        this.checkList = this.checkList.bind(this);
        this.clearInvalid = this.clearInvalid.bind(this);
    }

    checkList(){
        let value = this.email.value.trim();

        if(value !== ""){
            //getting rid of duplicate elements
            const emails = [...new Set(value.split(/,|,\s|;\s|\s/))];
            const {goodEmails, badEmails, repeatEmail} = this.breakUpElements(emails);

            this.sendEmails(goodEmails);
            this.handleBadEmails(badEmails);
            this.showRepeatEmail(repeatEmail);
        }
    }

    breakUpElements(emails){
        const currentMembers = this.props.members.map(data => data.email.toLowerCase());
        const pendingInvitations = this.getPendingInvitation(this.props.invites).map(email => email.toLowerCase());

        const hashCurrentMembers = new Set([...currentMembers, ...pendingInvitations]);

        return emails.reduce((accum, currentEmail) => {
                        if(!this.isEmail(currentEmail)){
                            accum.badEmails.push(currentEmail)
                            return accum;
                        }

                        if(hashCurrentMembers.has(currentEmail.toLowerCase())){
                            accum.repeatEmail.push(currentEmail);
                        }else{
                            accum.goodEmails.push(currentEmail)
                        }

                        return accum;
                    }, {goodEmails: [], repeatEmail: [], badEmails: []})
    }

    getPendingInvitation(invitations){
        return  invitations.reduce((accum, data) => {
                    if(['pending', 'created'].includes(data.state)) accum.push(data.email);
                    return accum;
                }, []);
    }

    sendEmails(emails){
        let { id: hubId, setLoading, handleError } = this.props;
        function handleInviteError(err, intent, customMessage) {
            if (err && err.status === 401) {
                handleError(null, intent, "Please refresh the page.")
            } else {
                handleError(err, intent, customMessage)
            }
        }
        emails.forEach(email => DataActionUtil.addMember(handleInviteError, { hubId, inviteEmail: email.trim().toLowerCase() }, setLoading))
    }

    handleBadEmails(emails){
        let value = this.email.value.trim();
        value = emails.filter(item => item !== "").join("; ");

        if(value !== ""){
            this.email.classList.add("invalid");
            this.email.value = value;
        }
    }

    showRepeatEmail(emails = []){
        if(emails.length == 0){return};

        emails = emails.reduce((accum, email) => `${accum} - ${email}<br/>`, "");

        this.props.setConfirmation(true, "Following invitations not sent:",
           emails + "<br>These emails are already members or pending.",
          ()=>{}, [], [], ()=>{}, false);
    }

    clearInvalid(){
        this.email.classList.remove("invalid")
    }

    isEmail(email){
        //https://html.spec.whatwg.org/#e-mail-state-(type=email)
        return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi.test(email)
    }

    render() {
        return  <div className="invitePeopleHub">
                    <h3>Invite new members:</h3>
                    <input type="text" placeholder="Enter email address" ref={input => this.email = input} onFocus={this.clearInvalid}/>
                    <p>Invited collaborators will be able to view and edit all contents in this {fullHubAlias}</p>
                    <button type="button" className="button" onClick={this.checkList}>Send</button>
                </div>
    }
}

module.exports = InvitePeopleHub;
